import axios from './index'
import prefix_ms from './prefix'

/** 分享页面访问上报 */
export const reportRecordVisitInfo = (shareRecordId) => {
  return axios.request({
    url: `${prefix_ms}/shareRecordVisitInfo/report/${shareRecordId}`,
    method: 'post',
  })
}

/** 获取接口访问凭证 */
export const getTicket = () => {
  return axios.request({
    url: `${prefix_ms}/ticket`,
    method: 'get'
  })
}



//////////////////
// WEBPACK FOOTER
// ./app/api/common.js
// module id = null
// module chunks = 